import axiosInstance from '@/api/http';
import { IResponse } from '@/api/IResponse';
import CreateApplicationModel from '@/models/applications/createApplicationModel';
import appSettings from '@/models/applications/appSetting';
import UpdateApplicationModel from '@/models/applications/updateApplicationModel';
import UpdateApplicationStatusModel from '@/models/applications/updateApplicationStatusModel';

export default class ApplicationService {
  /**
   * @description: 查询全部应用
   * @return {Promise}
   */
  static getAll = (): Promise<IResponse> => axiosInstance.get('application').then((res) => res.data);

  /**
   * @description: 新增应用
   * @params {CreateCustomerModel} params
   * @return {Promise}
   */
  static create = (params: CreateApplicationModel): Promise<IResponse> => axiosInstance.post('application', params).then((res) => res.data);

  /**
   * @description: 查询指定应用信息
   * @appId 应用Id
   * @return {Promise}
   */
  static get = (appId: string): Promise<IResponse> => axiosInstance.get(`application/${appId}`).then((res) => res.data);

  /**
   * @description: 修改指定应用信息
   * @appId 应用Id
   * @return {Promise}
   */
  static update = (params: UpdateApplicationModel, appId?: string): Promise<IResponse> => axiosInstance.put(`application/${appId}`, params).then((res) => res.data);

  /**
   * @description: 删除指定应用
   * @appId 应用Id
   * @return {Promise}
   */
  static delete = (appId: string): Promise<IResponse> => axiosInstance.delete(`application/${appId}`).then((res) => res.data);

  /**
   * 修改应用状态
   * @param appId  应用Id
   * @param params 修改状态对象
   * @returns IResponse
   */
  static updateStatus = (appId: string, params: UpdateApplicationStatusModel): Promise<IResponse> => axiosInstance.put(`application/updateStatus/${appId}`, params).then((res) => res.data);


   /**
   * @description: 查询文件过期时间
   * @appId 应用Id
   * @return {Promise}
   */
  static getFileExpiraTion = (appId: string): Promise<IResponse> => axiosInstance.get(`applicationsetting/${appId}`).then((res) => res.data);

  /**
   * @description: 设置应用配置
   * @appId 应用Id
   * @return {Promise}
   */
  static appSeting = (params: appSettings): Promise<IResponse> => axiosInstance.post('applicationsetting', params).then((res) => res.data);

  /**
   * @description: 获取应用配置
   * @appId 应用Id
   * @return {Promise}
   */
  static getAppSeting = (appId: string): Promise<IResponse> => axiosInstance.get(`applicationsetting/${appId}`).then((res) => res.data);

}
